import React from 'react';
import Slider from '@mui/material/Slider';
import { styled } from '@mui/material/styles';

const PrettoSlider = styled(Slider)({
  color: '#FF4367',
  height: 8,
  '& .MuiSlider-thumb': {
    height: 24,
    width: 24,
    backgroundColor: '#fff',
    border: '2px solid #FF4367',
    '&:focus, &:hover, &.Mui-active': {
      boxShadow: '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.3),0 0 0 1px rgba(0,0,0,0.02)',
    },
  },
  '& .MuiSlider-valueLabel': {
    fontSize: 14,
    fontWeight: 'bold',
    background: 'unset',
    padding: 4,
    borderRadius: '8px',
    backgroundColor: '#FF4367',
    color: '#fff',
  },
});

// Napredna funkcija za izračun "prijaznega" koraka za uporabnika
const getNiceStep = (range) => {
  if (range <= 0) return 1;
  const roughStep = range / 100; // Ciljamo na ~100 korakov
  const magnitude = Math.pow(10, Math.floor(Math.log10(roughStep)));
  const residual = roughStep / magnitude;

  let niceResidual;
  if (residual > 5) niceResidual = 10;
  else if (residual > 2) niceResidual = 5;
  else if (residual > 1) niceResidual = 2;
  else niceResidual = 1;
  
  // Zaokrožimo končni korak in zagotovimo, da ni manjši od 1
  return Math.max(1, Math.round(niceResidual * magnitude));
};


const PriceRangeFilter = ({ filters, setFilters, minPrice, maxPrice }) => {
  const safeMin = Number(minPrice) || 0;
  const safeMax = Number(maxPrice) || 9999999;
  const currentValues = Array.isArray(filters.priceRange)
    ? filters.priceRange.map(Number)
    : [safeMin, safeMax];

  // Napredno dinamično določanje koraka
  const priceRange = safeMax - safeMin;
  const step = getNiceStep(priceRange);

  const handleSliderChange = (event, newValue) => {
    setFilters({
      ...filters,
      priceRange: newValue, // Vrednosti so že števila
    });
  };

  const formatPrice = (value) => {
    return new Intl.NumberFormat('sl-SI', {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: 0,
    }).format(value); // .replace('€', '') + '€' ni več potreben
  };

  return (
    <div className="price-range-filter">
      <h3>Cenovni razpon</h3>
      <PrettoSlider
        value={currentValues}
        onChange={handleSliderChange}
        valueLabelDisplay="auto"
        min={safeMin}
        max={safeMax}
        step={step}
        valueLabelFormat={formatPrice}
      />
    </div>
  );
};

export default PriceRangeFilter;